// Sorts invoice numbers for display: numeric strings in numeric order and ahead of any
// non-numeric strings, which fall back to lexicographic order among themselves.
export const sortInvoiceNumbers = (nums: string[]): string[] =>
    [...nums].sort((a, b) => {
        const na = parseInt(a, 10);
        const nb = parseInt(b, 10);
        const aIsNum = !isNaN(na);
        const bIsNum = !isNaN(nb);
        if (aIsNum && bIsNum) return na - nb;
        if (aIsNum) return -1;
        if (bIsNum) return 1;
        return a.localeCompare(b);
    });
